<template>
  <div class="orderDetailContainer">
    <div class="title">Assignment TOPICE</div>
    <Person class="person" :showData="orderDetail.user" :orderDetail="orderDetail" v-if="role == 'writer'"></Person>
    <Person class="person" :showData="orderDetail.writer" :orderDetail="orderDetail" v-else></Person>
    <el-divider></el-divider>
    <OrderDetail class="orderDetail" :showData="orderDetail"></OrderDetail>
  </div>
</template>

<script>
import Person from '../person/person.vue';
import OrderDetail from '../order-detail/order-detail.vue';
export default {
  props: ['orderDetail'],
  name: 'order-detail',
  components: { Person, OrderDetail },
  data(){
    return {
      role:""
    }
  },
  mounted(){
    this.role = JSON.parse(localStorage.getItem("userInfo")).role
  }
};
</script>

<style lang="scss" scoped>
.orderDetailContainer {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 10px;
  .title {
    font-size: 25px;
    font-weight: bold;
    color: #000000;
    line-height: 35px;
    margin-left: 20px;
  }
  .person {
    margin-top: 30px;
  }
  .orderDetail {
    margin-top: 30px;
  }
}
</style>
